import { GraphQLQueryClass } from "@bsm/component";
import { TTimeOff } from "@bsm/graphql";

export class TimeOffQuery implements GraphQLQueryClass<TTimeOff, TResponse>{
    public queryKey: string = 'App.bsm-rh.timeoff';
    public gql: string = `
    query TimeOffQuery($id:Float){
        timeoff(filter:{id:$id}){
           id 
           description 
           dateBegin 
           dateEnd 
           hourBegin 
           hourEnd 
           status
           order
           entity
           entityId
           data
           dateArchive
           reason
           refusalReason
           solde
           countWorkingDays
           type {
               id
               designation
               isPaid
           }
           isDeletable 
           isEditable 
           isExpired
           isRSVP
           isRevocked
           isValidated
           isClosed
           isDeadLineRespected
           isWorkExtension
           notificationTime
           repetition
           repetitionDateStart
           repetitionDateEnd
           meet
           estimation
           progression
           relativePosition
           employee {
               id 
               fullName 
               firstName 
               lastName 
               profilePicture {
                   id 
                   name
               }
               department {
                   id
                   designation
               }
           }
           approvals {
               id
               approver {
                   id
                   fullName
               }
               isApproved
               isRefused
           }
           userCreator {
               id 
               employee {
                    id
                    fullName 
                    firstName 
                    lastName 
                    email 
                    profilePicture { 
                        id 
                        name 
                    }
               }
           }
           createdAt
           cover {
               id
           }
           files {
               id
               name
           }
           labels {
               id
               value
               color
           }
        }
      }
    `;
    variables?: any;
    constructor(variables?: any) {
        this.variables = variables;
    }
    mapFn(data: TResponse): TTimeOff {
        return data.timeoff
    };
}

export type TResponse = {
    timeoff: TTimeOff
}